module.exports = __webpack_public_path__ + "img/base_activites_parcours_orientation.1af10e0f.svg";